module.exports = __webpack_public_path__ + "img/3.3cec9b82.png";